import { clearToken } from "@bluefalcon/utils-package";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BF_SESSION_ID, BF_TOKEN, TENANT_NAME } from "../../constants/cookies.constants";

type LogoutProps = {
    routeOnLogout?: string;
};

export function Logout({
    routeOnLogout,
}: LogoutProps) {
    const navigate = useNavigate();

    const clearAll = () => {
        clearToken(BF_TOKEN);
        clearToken(TENANT_NAME);
        clearToken(BF_TOKEN);
        clearToken(BF_SESSION_ID);
    };

    useEffect(() => {
        clearAll();
        navigate(`/${routeOnLogout ?? 'login'}`);
    }, []);

    return (<div />);
}
